import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, delay, ease: EASE }}
        className={className}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children }) => (
    <p className="font-mono text-xs font-semibold uppercase tracking-[0.3em] text-sky-400 sm:text-sm">
        {children}
    </p>
);
